module.exports = __webpack_public_path__ + "img/story.271271bd.png";